import React, { useState, useEffect, useRef } from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { InputText } from 'primereact/inputtext';
import Loader from "../Shared/Loader/Loader";
import { Dropdown } from 'primereact/dropdown';
import APIConstant from "../../utils/pathConstants";
import api from "../../utils/apiClient";
import CommonConfig from '../../utils/constant';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { useNavigate } from 'react-router-dom';
import Toast from '../Shared/Toast/Toast';
import moment from 'moment';
import UploadFile from '../UploadFile/UploadFile';
import { apiBase } from '../../utils/config';
import { MultiSelect } from 'primereact/multiselect';
import DeleteConfirmation from '../Dialogs/DeleteConfirmation';
import { useCatchResponse } from '../../utils/useCatchResponse';


const StudentProfile = () => {
    const { catchResponse } = useCatchResponse();
    const navigate = useNavigate();
    const fileUploadRef = useRef(null);
    const [personalDetailId, setPersonalDetailId] = useState('');
    const [profilePath, setProfilePath] = useState(null);
    const [userName, setUserName] = useState('');
    const [panNo, setPanNo] = useState('');
    const [gstNo, setGSTNo] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [emailAddress, setEmailAddress] = useState("");
    const [emailErr, setEmailErr] = useState(false);
    const [emailErrText, setEmailErrText] = useState('');
    const [pinCode, setPinCode] = useState('');
    const [currentAddress, setCurrentAddress] = useState('');
    const [planName, setPlanName] = useState('');
    const [planRange, setPlanRange] = useState(null);
    const [selectedGender, setSelectedGender] = useState(null);
    const [selectedBloodGroup, setSelectedBloodGroup] = useState(null);
    const [selectedNationality, setSelectedNationality] = useState(null);
    const [selectedReligion, setSelectedReligion] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [languages, setLanguages] = useState([]);
    const [aadharNo, setAadharNo] = useState('');
    const [aadharOTP, setAadharOTP] = useState('');
    const [isAadharVerify, setIsAadharVerify] = useState(false);
    const [dob, setDob] = useState(null);
    const genderOptions = [{ label: 'Male', value: 'male' }, { label: 'Female', value: 'female' }];
    const nationalityOptions = [{ label: 'Indian', value: 'indian' }, { label: 'Other', value: 'other' }];
    const [age, setAge] = useState('');
    const [languageList, setLanguageList] = useState([]);
    const [bloodList, setBloodList] = useState([]);
    const [religionList, setReligionList] = useState([]);
    const [casteList, setCasteList] = useState([]);
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [previewProfilePath, setPreviewProfilePath] = useState('');
    const [isProfileAllowed, setIsProfileAllowed] = useState(false);
    const [isNoLogin, setIsNoLogin] = useState(false);

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        GetLanguageList(loginData?._id);
        GetBloodList(loginData?._id);
        GetCasteList(loginData?._id);
        GetReligionList(loginData?._id);
        GetUserDetail(loginData?._id);
        getPersonDetail(loginData?._id);
    }, []);

    const GetUserDetail = async (userid) => {
        try {
            let data = {
                id: userid,
            }
            await api.post(APIConstant.path.getUserById, data).then(async response => {
                let res = response;
                if (res.success) {
                    setUserName(res?.data?.Name);
                    setMobileNumber(res?.data?.Phone);
                    setEmailAddress(res?.data?.Email);
                    setPlanName(res?.data?.PlanId);
                    setIsNoLogin(res?.data?.IsNoLogin);
                    setPlanRange([res?.data?.PlanStartDate ? new Date(res?.data?.PlanStartDate) : '', res?.data?.PlanEndDate ? new Date(res?.data?.PlanEndDate) : ''])
                    setProfilePath(res?.data?.ProfilePhotoUrl ? `${apiBase}/UserProfilePic/${res?.data?.ProfilePhotoUrl}` : null);
                    setIsProfileAllowed(res?.data?.IsAllowed);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetLanguageList = async (id) => {
        try {
            await api.get(APIConstant.path.getLanguageList).then(async response => {
                let res = response;
                if (res.success) {
                    setLanguageList(res.data.map(x => ({
                        ...x,
                        label: x?.LanguageName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetBloodList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getBloodList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setBloodList(res.data.map(x => ({
                        label: x?.BloodName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetCasteList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getCasteList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setCasteList(res.data.map(x => ({
                        label: x?.CasteName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const GetReligionList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getReligionList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setReligionList(res.data.map(x => ({
                        label: x?.ReligionName,
                        value: x?._id
                    })));
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const getPersonDetail = async (ID) => {
        try {
            let data = {
                id: ID,
            };
            await api
                .post(APIConstant.path.GetPersonalDetailById, data)
                .then(async (response) => {
                    let res = await response;
                    if (res.success) {
                        Loader.hide();
                        setPersonalDetailId(res?.data?._id);
                        setCurrentAddress(res?.data?.CurrentAddress);
                        setPinCode(res?.data?.PinCode);
                        setAadharNo(res?.data?.AadharNo);
                        setSelectedGender(res?.data?.Gender);
                        setDob(new Date(res?.data?.DOB) || '');
                        setAge(res?.data?.Age);
                        setSelectedNationality(res?.data?.Nationality);
                        setSelectedBloodGroup(res?.data?.BloodGroup);
                        setSelectedReligion(res?.data?.Religion);
                        setSelectedCategory(res?.data?.Category);
                        setLanguages(res?.data?.Language?.split(',') || []);
                    }
                })
                .catch((err) => {
                    Loader.hide();
                    console.log(err);
                });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    };

    const handleSave = async () => {
        await AddEditPersonalDetail();
        await AddEditUserDetail();
        await onReferesh();
    }

    const onReferesh = () => {
        GetUserDetail(securityUserID);
        getPersonDetail(securityUserID);
    }

    const AddEditPersonalDetail = async () => {
        try {
            let data = {
                PersonalId: personalDetailId,
                UserId: securityUserID,
                PinCode: pinCode,
                CurrentAddress: currentAddress,
                AadharNo: aadharNo,
                Gender: selectedGender,
                DOB: dob ? moment(dob).format("YYYY-MM-DD") : '',
                Age: age,
                Nationality: selectedNationality,
                BloodGroup: selectedBloodGroup,
                Religion: selectedReligion,
                Category: selectedCategory,
                Language: languages.length > 1 ? languages.join(',') : languages[0],
                CreatedBy: securityUserID,
            };
            Loader.show();
            await api.post(APIConstant.path.AddPersonalDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                } else {
                    Toast.error({ message: res.message });
                    Loader.hide();
                }
            })
                .catch(() => {
                    Loader.hide();
                });
        } catch (err) {
            console.log(err);
            Loader.hide();
            catchResponse(err);
        }
    };

    const handleFileSelect = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
                const img = new Image();
                img.onload = () => {
                    const aspectRatio = img.height / img.width;
                    const expectedRatio = 4 / 3;
                    const tolerance = 0.01;

                    if (Math.abs(aspectRatio - expectedRatio) <= tolerance) {
                        setProfilePath(selectedFile);
                        const fileURL = URL.createObjectURL(selectedFile);
                        setPreviewProfilePath(fileURL);
                    } else {
                        if (fileUploadRef.current) {
                            fileUploadRef.current.clear();
                        }
                        Toast.error({ message: 'The image must have a 4:3 aspect ratio.' });
                    }
                };
                img.onerror = () => {
                    if (fileUploadRef.current) {
                        fileUploadRef.current.clear();
                    }
                    Toast.error({ message: 'Error loading the image.' });
                };
                const reader = new FileReader();
                reader.onload = (event) => {
                    img.src = event.target.result;
                };
                reader.readAsDataURL(selectedFile);
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
        const numericValue = value.replace(/[^0-9]/g, '');
        if (type === 'PAN') {
            setPanNo(alphanumericValue.toUpperCase().trim());
        } else if (type === 'GST') {
            setGSTNo(alphanumericValue);
        } else if (type === 'MobileNo') {
            setMobileNumber(numericValue);
        } else if (type === 'PinCode') {
            setPinCode(numericValue);
        }

    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        const maxLength = 50;
        if (value.length <= maxLength) {
            setEmailAddress(value);
        }
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(value)) {
            setEmailErr(true);
            setEmailErrText('Please enter a valid email address.');
        } else {
            setEmailErr(false);
            setEmailErrText('');
        }
    };

    const AddEditUserDetail = async () => {
        try {
            const formData = new FormData();
            formData.append("id", securityUserID);
            formData.append("Name", userName);
            formData.append("Email", emailAddress);
            formData.append("Phone", mobileNumber);
            formData.append("IsNoLogin", isNoLogin);
            if (profilePath && profilePath.type) {
                formData.append("userProfilePic", profilePath);
            } else if (CommonConfig.isEmpty(profilePath)) {
                formData.append("userProfilePic", '');
            }
            Loader.show();
            await api.post(APIConstant.path.AddUpdateUser, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
                .then(async (response) => {
                    let res = response;
                    if (res.success) {
                        Toast.success({ message: 'User details updated successfully' });
                        const event = new CustomEvent("userProfileUpdated");
                        window.dispatchEvent(event);
                    } else {
                        Toast.error({ message: res.message });
                    }
                    Loader.hide();
                })
                .catch((err) => {
                    console.error(err);
                    Toast.error({ message: 'Failed to update user details' });
                    Loader.hide();
                });
        } catch (err) {
            console.log(err);
            Toast.error({ message: 'An error occurred' });
            Loader.hide();
            catchResponse(err);
        }
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    setProfilePath('')
                    setPreviewProfilePath('');
                    handleClose()
                }}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleBack = () => {
        const loginData = CommonConfig.loginData();
        CommonConfig.getUserMenu(loginData, navigate, 'Login');
    }

    return (
        <div className='p-p-0 wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between p-py-3 p-mx-3">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-user-edit"></i>
                    <h2 className='p-m-0'>User Profile</h2>
                </div>
            </div>
            <div className="e-edit-profile-main p-px-3">
                <div className="p-grid">
                    <div className="p-col-12 p-md-4" style={{ height: 265 }}>
                        <UploadFile label='' note='' preview={previewProfilePath} original={profilePath} uploadHandler={handleFileSelect} uploadRef={fileUploadRef} handleDelete={() => setIsDeleteConfirmation(true)} isEditAllow={isProfileAllowed} aspectRatio={1 / 1} />
                    </div>
                    <div className="p-col-12 p-md-8">
                        <div className="p-grid">
                            <div className="p-col-12 p-md-6">
                                <div className="custom-inputs"><p className='p-m-0'>Name</p>
                                    <InputText className='p-w-100 p-mt-1' value={userName} maxLength={20} onChange={(e) => setUserName(e.target.value)} style={{ fontFamily: "Noto Sans, Arial, sans-serif" }} />
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="custom-inputs"><p className='p-m-0'>Aadhar</p>
                                    <div className="p-inputgroup p-mt-1">
                                        <InputText id="aadhar" className='p-w-100' value={aadharNo} maxLength={12} onChange={(e) => handleChange(e, 'AadharNo')} />
                                        <Button label="Verify" />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="custom-inputs"><p className='p-m-0'>Email Address</p>
                                    <InputText className='p-w-100 p-mt-1' id="emailAddress" value={emailAddress} onChange={(e) => handleEmailChange(e)} disabled />
                                    <span className="p-error block" style={{ color: 'red' }}>{emailErr ? emailErrText : null}</span>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-6">
                                <div className="custom-inputs"><p className='p-m-0'>Contact Number</p>
                                    <InputText className='p-w-100 p-mt-1' id="contactNo" maxLength={10} value={mobileNumber} onChange={(e) => handleChange(e, 'MobileNo')} disabled />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="p-grid">
                    <div className="p-col-12 p-md-4"><div className="custom-inputs"><p className='p-m-0'>Gender</p>
                        <Dropdown id="gender" className='p-w-100 p-mt-1' value={selectedGender} options={genderOptions} onChange={(e) => setSelectedGender(e.value)} placeholder="Select Gender" filter showClear /></div></div>
                    <div className="p-col-12 p-md-4"><div className="custom-inputs"><p className='p-m-0'>Date of Birth</p>
                        <Calendar id="dob" className='p-w-100 p-mt-1' value={dob} onChange={(e) => setDob(e.value)} showIcon dateFormat='dd/mm/yy' maxDate={new Date()} /></div></div>
                    <div className="p-col-12 p-md-4"><div className="custom-inputs"><p className='p-m-0'>Age</p>
                        <InputText id="age" className='p-w-100 p-mt-1' maxLength={2} value={age} onChange={(e) => handleChange(e, 'Age')} /></div></div>
                    <div className="p-col-12 p-md-4"><div className="custom-inputs"><p className='p-m-0'>Nationality</p>
                        <Dropdown id="nationality" className='p-w-100 p-mt-1' value={selectedNationality} options={nationalityOptions} onChange={(e) => setSelectedNationality(e.value)} placeholder="Select Nationality" filter showClear /></div></div>
                    <div className="p-col-12 p-md-4"><div className="custom-inputs"><p className='p-m-0'>Blood Group</p>
                        <Dropdown id="bloodGroup" className='p-w-100 p-mt-1' value={selectedBloodGroup} options={bloodList} onChange={(e) => setSelectedBloodGroup(e.value)} placeholder="Select Blood Group" filter showClear /></div></div>
                    <div className="p-col-12 p-md-4"><div className="custom-inputs"><p className='p-m-0'>Religion</p>
                        <Dropdown id="religion" className='p-w-100 p-mt-1' value={selectedReligion} options={religionList} onChange={(e) => setSelectedReligion(e.value)} placeholder="Select Religion" filter showClear /></div></div>
                    <div className="p-col-12 p-md-4"><div className="custom-inputs"><p className='p-m-0'>Category</p>
                        <Dropdown id="category" className='p-w-100 p-mt-1' value={selectedCategory} options={casteList} onChange={(e) => setSelectedCategory(e.value)} placeholder="Select Category" filter showClear /></div></div>
                    <div className="p-col-12 p-md-4"><div className="custom-inputs"><p className='p-m-0'>Languages Spoken</p>
                        <MultiSelect id="languages" className='p-w-100 p-mt-1' value={languages} options={languageList} onChange={(e) => setLanguages(e.value)} placeholder="Select language" filter display='chip' /></div></div>
                    <div className="p-col-12 p-md-4"><div className="custom-inputs"><p className='p-m-0'>Pin Code</p>
                        <InputText id="pinCode" className='p-w-100 p-mt-1' maxLength={6} value={pinCode} onChange={(e) => handleChange(e, 'PinCode')} /></div></div>
                    <div className="p-col-12 p-md-4"><div className="custom-inputs"><p className='p-m-0'>Plan Name</p>
                        <InputText id="planName" className='p-w-100 p-mt-1' value={planName} disabled /></div></div>
                    <div className="p-col-12 p-md-4"><div className="custom-inputs"><p className='p-m-0'>Plan Duration</p>
                        <Calendar value={planRange} selectionMode="range" readOnlyInput disabled dateFormat="dd/mm/yy" showIcon className="p-w-100 p-mt-1" showButtonBar /></div></div>
                    <div className="p-col-12 p-md-8"><div className="custom-inputs"><p className='p-m-0'>Current Address</p>
                        <InputTextarea className='p-w-100 p-mt-1' id="currentAddress" value={currentAddress} rows={3} cols={30} onChange={(e) => setCurrentAddress(e.target.value)} /></div></div>
                </div>
                <div className="edit-profile-footer p-mx-3 p-d-flex p-ai-center p-jc-end">
                    <Button label="Cancel" className="p-m-0 btn-text-action-secondary" onClick={() => handleBack()} />
                    <Button label="Save" className="p-m-0 btn-text-action-primary p-m-1" onClick={() => handleSave()} />
                </div>
            </div>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>
    );
};

export default StudentProfile;
